<template>
  <div class="auth-setting-page">
    <common-bg-plate v-loading="loading">
      <detail-section title="配置权限">
        <div class="title-bar">
          <el-avatar size="medium">
            <img :src="avatarImg" />
          </el-avatar>
          <span class="label">角色名称:</span>
          <span class="name">{{ roleName }}</span>
        </div>
        <div class="config-wrap">
          <div class="select-all">
            <span>配置菜单/按钮权限</span>
            <el-checkbox v-model="checkAllStatus" :disabled="!editAble" @change="checkAll()"
              >全部</el-checkbox
            >
          </div>
          <div v-for="item in result" :key="item.ID" class="config-content">
            <div
              :class="['section-title', !$utils.isEmpty(item.Children) ? 'can-expand' : '']"
              @click="!$utils.isEmpty(item.Children) ? changeExpand(item.ID) : () => {}"
            >
              <el-checkbox
                v-model="item.IsChecked"
                :disabled="!editAble"
                @change="handleChecked(item.Children, item.IsChecked, item)"
                >{{ item.modelName }}</el-checkbox
              >
              <span
                v-show="!$utils.isEmpty(item.Children)"
                :class="['arrow', 'el-icon-arrow-right', item.isExpand ? 'is-expand' : '']"
              ></span>
            </div>
            <div :class="['child-wrap', item.isExpand ? 'is-expand' : '']">
              <div class="child-wrap-content">
                <el-table
                  ref="table"
                  :data="genTableData(item)"
                  :span-method="objectSpanMethod"
                  :border="true"
                >
                  <el-table-column prop="func" label="功能" min-width="150">
                    <template slot-scope="{ row }">
                      <el-checkbox
                        v-model="row.func.IsChecked"
                        :disabled="!editAble"
                        @change="handleChecked(row.func.Children, row.func.IsChecked, row.func)"
                        >{{ row.func.modelName }}</el-checkbox
                      >
                    </template>
                  </el-table-column>
                  <el-table-column prop="subFunc" label="子功能" min-width="150">
                    <template slot-scope="{ row }">
                      <el-checkbox
                        v-if="row.subFunc"
                        v-model="row.subFunc.IsChecked"
                        :disabled="!editAble"
                        @change="
                          handleChecked(row.subFunc.Children, row.subFunc.IsChecked, row.subFunc)
                        "
                        >{{ row.subFunc.modelName }}</el-checkbox
                      >
                    </template>
                  </el-table-column>
                  <el-table-column prop="funcPoint" label="功能点" min-width="700">
                    <template slot-scope="{ row }">
                      <el-checkbox
                        v-for="(fItem, index) in row.funcPoint"
                        :key="index"
                        v-model="fItem.IsChecked"
                        :disabled="!editAble"
                        @change="handleChildChecked(fItem.IsChecked, fItem, result)"
                        >{{ fItem.modelName }}</el-checkbox
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
          <div class="btn-position">
            <el-button size="small" @click="clearRevise()">取消</el-button>
            <el-button
              size="small"
              type="primary"
              :disabled="!editAble || saveLoading"
              @click="saveMenu()"
            >保存</el-button>
          </div>
        </div>
      </detail-section>
    </common-bg-plate>
  </div>
</template>

<script>
import avatarImg from '@/assets/images/system/avatar.png'
import { mapActions } from 'vuex'
export default {
  name: 'SettingAuth',
  data() {
    return {
      avatarImg,
      checked: false,
      initCheckedKeys: [],
      initUnCheckedKeys: [], //记录初始值
      checkedKeys: [],
      unCheckedKeys: [],
      result: [],
      keys: [],
      checkAllStatus: false,
      roleName: '',
      title: '配置权限',
      btns: {},
      menus: {},
      allFuncs: {},
      loading: true,
      saveLoading: false
    }
  },
  computed: {
    editAble: function() {
      const roleID = this.$route.query.roleId
      return roleID != 1
    }
  },
  mounted() {
    this.roleName = this.$route.query.roleName
    const roleID = this.$route.query.roleId
    this.getRoleModule(roleID)
  },
  methods: {
    ...mapActions(['updateResourceList']),
    getRoleModule(roleID) {
      this.$apis.system
        .getRoleAuth({ roleID })
        .then(response => {
          if (response?.data) {
            this.list = response.data
            this.handleData()
          }
          this.loading = false
        })
        .catch(err => {
          this.loading = false
        })
    },
    //初始化设置伸展状态,全选状态
    handleData() {
      this.result = this.setStatus(this.list)
      this.recordInitKeys(this.list)
      let mergeArr = this.initCheckedKeys.concat(this.initUnCheckedKeys)
      this.checkAllStatus = mergeArr.length === this.initCheckedKeys.length ? true : false
    },
    setStatus(data) {
      data.forEach(ele => {
        if (!this.$utils.isEmpty(ele.Children)) {
          this.$set(ele, 'isExpand', true)
          this.setStatus(ele.Children)
        } else {
          this.$set(ele, 'isExpand', false)
        }
      })
      return data
    },
    //记录初始keys状态
    recordInitKeys(data) {
      data.forEach(ele => {
        if (ele.IsChecked && !this.initCheckedKeys.includes(ele.ID)) {
          this.initCheckedKeys.push(ele.ID)
        } else {
          this.initUnCheckedKeys.push(ele.ID)
        }
        if (!this.$utils.isEmpty(ele.Children)) {
          this.recordInitKeys(ele.Children)
        }
      })
    },
    //保存之前更新checkedKeys数组
    handleKeys(data) {
      data.forEach(ele => {
        if (ele.IsChecked && !this.checkedKeys.includes(ele.ID)) {
          this.checkedKeys.push(ele.ID)
        } else {
          if (ele.IsChecked === false && this.checkedKeys.includes(ele.ID)) {
            this.checkedKeys.map((item, index) => {
              if (item === ele.ID) this.checkedKeys.splice(index, 1)
            })
          } else {
            this.unCheckedKeys.push(ele.ID)
          }
        }
        if (!this.$utils.isEmpty(ele.Children)) {
          this.handleKeys(ele.Children)
        }
      })
    },
    //全选
    checkAllBox(data) {
      data.forEach(ele => {
        ele.IsChecked = this.checkAllStatus
        if (!this.$utils.isEmpty(ele.Children)) {
          this.checkAllBox(ele.Children)
        }
      })
    },
    checkAll() {
      this.checkAllBox(this.result)
    },
    //选中父节点，子节点自动全选/取消
    handleChecked(data, checked, node) {
      if (!this.$utils.isEmpty(data)) {
        data.forEach(item => {
          item.IsChecked = checked
          if (!this.$utils.isEmpty(item.Children)) {
            this.handleChecked(item.Children, item.IsChecked, node)
          }
        })
      }
      // 如果父节点还有父节点，需要一起选上
      if (node.parentID !== 0) {
        this.handleChildChecked(node.IsChecked, node, this.result)
      }
      this.checkAllStatus = this.isAllChecked(this.result)
    },
    // 选中子节点，父节点也勾选
    handleChildChecked(isChecked, node, result) {
      if (isChecked) {
        result.forEach(ele => {
          if (ele.ID === node.parentID) {
            ele.IsChecked = isChecked
            if (ele.parentID !== 0) {
              this.handleChildChecked(ele.IsChecked, ele, this.result)
            }
          }
          if (!this.$utils.isEmpty(ele.Children)) {
            this.handleChildChecked(isChecked, node, ele.Children)
          }
        })
      }
      this.checkAllStatus = this.isAllChecked(this.result)
    },
    //节点展开/收起
    changeExpand(id) {
      this.result.forEach(ele => {
        if (ele.ID === id) ele.isExpand = !ele.isExpand
      })
    },
    diffAuth(data) {
      data.forEach(ele => {
        if (ele.IsChecked && ele.type === 'menu') {
          this.menus[ele.ID] = ele.ID
        }
        if (ele.IsChecked && ele.type === 'button') {
          this.btns[ele.ID] = ele.ID
        }
        this.allFuncs[ele.ID] = ele.ID
        if (!this.$utils.isEmpty(ele.Children)) {
          this.diffAuth(ele.Children)
        }
      })
    },
    clearRevise() {
      this.$router.replace({
        name: 'role'
      })
    },
    saveMenu() {
      this.handleKeys(this.result)
      let sendData = []
      //判断选中变化的内容选中—>未选中
      this.initCheckedKeys.map(elem => {
        if (this.unCheckedKeys.includes(elem)) {
          let item = {
            id: elem,
            isChecked: false
          }
          sendData.push(item)
        }
      })
      //判断选中变化的内容未选中—>选中
      this.initUnCheckedKeys.map(elem => {
        if (this.checkedKeys.includes(elem)) {
          let item = {
            id: elem,
            isChecked: true
          }
          sendData.push(item)
        }
      })
      //没有选择资源
      const keys = this.checkedKeys
      if (this.$utils.isEmpty(keys)) {
        this.$message.error('请选择资源')
        return
      }
      //资源没有改变
      if (this.$utils.isEmpty(sendData)) {
        this.$message.error('您未修改任何权限配置！')
        return
      }

      this.saveLoading = true
      let param = {
        roleId: parseInt(this.$route.query.roleId),
        modules: sendData
      }
      let self = this
      this.$apis.system.reviseRoleAuth(param).then(res => {
        if (res) {
          self.$message.success('角色资源配置成功')
          const roleId = self.$route.query.roleId
          self.$router.replace({
            name: 'role'
          })

          const userInfoStr = localStorage.getItem('cbaas_system_userInfo')
          const userInfo = userInfoStr ? JSON.parse(userInfoStr) : {}

          if (userInfo.roleID == roleId) {
            self.$apis.system.getRoleAuth({ roleID: roleId }).then(res => {
              if (res.data) {
                self.diffAuth(res.data)
                localStorage.setItem('cbaas_system_btns_auth', JSON.stringify(self.btns))
                localStorage.setItem('cbaas_system_menus_auth', JSON.stringify(self.menus))
                localStorage.setItem('cbaas_system_all_auth', JSON.stringify(self.allFuncs))
                self.$store.dispatch('updateResourceList', {
                  menus: self.menus,
                  btns: self.btns,
                  allFuncs: self.allFuncs
                })

                self.list = res.data
                self.handleData()
              }
              self.saveLoading = false
            }).catch(err => {
              self.saveLoading = false
            })
          } else {
            self.saveLoading = false
          }
        }
      }).catch(err => {
        self.saveLoading = false
      })
    },
    genTableData(module) {
      let r = []
      for (let i = 0; i < module.Children?.length; i++) {
        let item1 = module.Children[i]
        if (item1.Children && item1.Children.length > 0) {
          for (let j = 0; j < item1.Children.length; j++) {
            let item2 = item1.Children[j]
            r.push({
              func: item1,
              subFunc: item2,
              funcPoint: item2.Children,
              funcSpan: j == 0 ? item1.Children.length : -1
            })
          }
        } else {
          r.push({
            func: item1,
            funcSpan: 0
          })
        }
      }
      return r
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (row.funcSpan > 0) {
          return {
            rowspan: row.funcSpan,
            colspan: 1
          }
        } else if (row.funcSpan < 0) {
          return {
            rowspan: 0,
            colspan: 0
          }
        } else {
          return {
            rowspan: 1,
            colspan: 1
          }
        }
      }
    },
    isAllChecked(result) {
      let r = true
      for (let i = 0; i < result.length; i++) {
        if (!this.isFuncAllChecked(result[i])) {
          r = false
          break
        }
      }
      return r
    },
    isFuncAllChecked(func) {
      let r = func.IsChecked
      if (r && func.Children) {
        for (let i = 0; i < func.Children.length; i++) {
          if (!this.isFuncAllChecked(func.Children[i])) {
            r = false
            break
          }
        }
      }
      return r
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme(
  'auth-setting-page',
  (
    --table-border-color: var(--base-border-color-base),
    --table-row-background-color: var(--base-background-color-base),
    --section-title-bg-image: url('~@/assets/images/system/title-bg.png')
  ),
  (
    --table-border-color: var(--base-border-color-light),
    --table-row-background-color: var(--base-color-white),
    --section-title-bg-image: none
  )
);

.auth-setting-page {
  @include adaptation(
    (
      --avatar-size: 32px,
      --title-bar-name-margin-left: 6px,
      --title-bar-margin-bottom: 16px,
      --common-line-height: 32px,
      --common-gap: 12px,
      --common-gap-large: 24px,
      --expand-arrow-size: 6px,
      --table-cell-padding: 6px 0,
      --table-line-height: 20px
    )
  );

  .common-bg-plate {
    min-height: var(--base-main-router-body-avaliable-height);
  }

  .title-bar {
    display: flex;
    align-items: center;
    margin-bottom: var(--title-bar-margin-bottom);

    .el-avatar {
      width: var(--avatar-size);
      height: var(--avatar-size);
      line-height: var(--avatar-size);
      margin-right: var(--common-gap);
      background-color: transparent;
    }

    .label {
      color: var(--base-color-text-regular);
    }

    .name {
      color: var(--base-color-text-primary);
      margin-left: var(--title-bar-name-margin-left);
    }
  }

  .config-wrap {
    .select-all {
      height: var(--common-line-height);
      line-height: var(--common-line-height);
      margin-bottom: var(--common-gap);

      span {
        margin-right: var(--common-gap);
      }
    }

    .config-content {
      margin-bottom: var(--common-gap-large);

      .section-title {
        background-image: var(--section-title-bg-image);
        background-size: 100% 100%;
        background-color: var(--base-background-color-light);
        height: var(--common-line-height);
        width: 100%;
        line-height: var(--common-line-height);
        padding-left: var(--common-gap);
        align-items: center;
        display: flex;

        &.can-expand {
          cursor: pointer;
        }
      }

      .arrow {
        display: inline-block;
        margin-left: var(--base-size-8);
        margin-top: var(--base-size-2);
        cursor: pointer;
        position: relative;

        &.is-expand {
          transform: rotateZ(90deg);
        }

        transition: transform 0.2s ease-in;
      }

      .child-wrap {
        position: relative;
        transition: grid-template-rows 0.3s ease;
        display: grid;
        grid-template-rows: 0fr;

        .child-wrap-content {
          overflow: hidden;
        }

        &.is-expand {
          height: 100%;
          grid-template-rows: 1fr;
        }

        .el-table {
          /deep/ {
            .el-table__cell {
              padding: var(--table-cell-padding);
              line-height: var(--table-line-height);
              border-right-color: var(--table-border-color);
              border-bottom-color: var(--table-border-color);
            }

            .el-table__row, .el-table__header .el-table__cell {
              background-color: var(--table-row-background-color);
            }

            .el-table__body {

              .el-checkbox {
                color: var(--base-color-text-primary);
              }
            }
          }

          &::before {
            background-color: var(--table-border-color) !important;
          }
        }

        .el-table--border {
          border-color: var(--table-border-color);

          &::after {
            background-color: var(--table-border-color) !important;
          }
        }
      }
    }

    .btn-position {
      justify-content: center;
      display: flex;
    }
  }
}
</style>
